module.exports = __webpack_public_path__ + "static/the-martian-f15d7ad6839c7dcc1f13ecf279dc4568.jpg";